require('./bootstrap');

import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import store from './store.js'
import helpers from './helpers.js';

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Funnl Platform` : 'Funnl Platform',
  setup({ el, app, props, plugin }) {
      const vapp = createApp({ render: () => h(app, props) });
      vapp.use(plugin);
      vapp.config.globalProperties.$store = store;
      vapp.config.globalProperties.$helpers = helpers;
      vapp.mount(el);
      return vapp;
  },
})
